/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import { useSelector } from 'react-redux';
import TaxProdList from '../../../components/TaxPortal/TaxProd/TaxProdList';
import Contracts from '../../../components/TaxPortal/Contract/Contracts';
import queryString from "query-string";

const ContractPage = () => {
  const history = useHistory();
  const { employee } = useSelector(
    (store) => ({
      employee: store.Profile.employee,
    }),
  );
  const [activeTab, setActiveTab] = useState("contract");

  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`
    });
    setActiveTab(value);
  };

  const tabList = [
    {
      label: "계약 관리",
      action: _setActiveTab,
      value: "contract",
    },
    {
      label: "세무상품 관리",
      action: _setActiveTab,
      value: "taxProd",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    <>
      <PageHeader title={`${employee && employee.name}님, 안녕하세요`}
        activeTab={activeTab}
        tabList={tabList} />
      {activeTab === "contract" && <Contracts />}
      {activeTab === "taxProd" && <TaxProdList />}
    </>

  );
};

export default ContractPage;